(() => {
  const SELECTOR_ROOT = '[data-article-pcarousel]';
  const quickviewCache = new Map();

  function getSlideStep(track) {
    const slide = track.querySelector('.article-pcarousel__slide');
    if (!slide) return track.clientWidth;
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function updateNav(root) {
    const track = root.querySelector('[data-article-pcarousel-track]');
    const prev = root.querySelector('[data-article-pcarousel-prev]');
    const next = root.querySelector('[data-article-pcarousel-next]');
    if (!track || !prev || !next) return;

    // Subpixel-safe: ignore 1–3px rounding overflow so 3-up / 2-up layouts don't show arrows
    const overflow = track.scrollWidth - track.clientWidth;
    const canScroll = overflow > 4;
    const maxScroll = Math.max(0, overflow);
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft >= maxScroll - 2;

    // Hide arrows when all slides fit; layout/grid columns stay the same
    root.classList.toggle('article-pcarousel--no-overflow', !canScroll);

    prev.disabled = !canScroll || atStart;
    next.disabled = !canScroll || atEnd;
    prev.setAttribute('aria-disabled', String(prev.disabled));
    next.setAttribute('aria-disabled', String(next.disabled));
    prev.setAttribute('aria-hidden', String(!canScroll));
    next.setAttribute('aria-hidden', String(!canScroll));
    prev.tabIndex = canScroll ? 0 : -1;
    next.tabIndex = canScroll ? 0 : -1;
  }

  function closeAllSizePopups(exceptCard) {
    document.querySelectorAll('[data-article-pcard].article-pcard--size-open').forEach((card) => {
      if (exceptCard && card === exceptCard) return;
      closeSizePopup(card);
    });
  }

  function updateSizeAtc(card, available) {
    const atc = card.querySelector('[data-article-pcard-size-atc]');
    if (!atc) return;
    const labelAvailable = atc.dataset.labelAvailable || 'Add to bag';
    const labelSoldOut = atc.dataset.labelSoldOut || 'Sold out';
    atc.disabled = !available;
    atc.textContent = available ? labelAvailable : labelSoldOut;
    atc.classList.toggle('is-soldout', !available);
  }

  function openSizePopup(card) {
    const popup = card.querySelector('[data-article-pcard-size-popup]');
    if (!popup) return;
    closeAllSizePopups(card);
    popup.hidden = false;
    card.classList.add('article-pcard--size-open');

    const selected = card.querySelector('[data-article-pcard-size].is-selected');
    const variantInput = card.querySelector('[data-article-pcard-variant]');
    if (selected) {
      const variantId = selected.getAttribute('data-variant-id');
      if (variantInput && variantId) variantInput.value = variantId;
      updateSizeAtc(card, selected.getAttribute('data-available') === 'true');
    } else {
      updateSizeAtc(card, false);
    }
  }

  function closeSizePopup(card) {
    const popup = card.querySelector('[data-article-pcard-size-popup]');
    if (popup) popup.hidden = true;
    card.classList.remove('article-pcard--size-open');
  }

  function ensureBlogProductQuickviewScript() {
    if (customElements.get('blog-product-quickview')) return Promise.resolve();
    const map = window.components || {};
    const src = map['blog-product-quickview'];
    if (!src) return Promise.resolve();
    if (document.querySelector(`script[src="${src}"]`)) {
      return customElements.whenDefined('blog-product-quickview').catch(() => {});
    }
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => resolve();
      document.body.appendChild(script);
    }).then(() => customElements.whenDefined('blog-product-quickview').catch(() => {}));
  }

  function prefetchQuickview(handle) {
    if (!handle || quickviewCache.has(handle)) return;
    quickviewCache.set(handle, true);
    ensureBlogProductQuickviewScript().then(() => {
      if (window.BlogProductQuickviewPrefetch) window.BlogProductQuickviewPrefetch(handle);
    });
  }

  function openQuickview(root, handle) {
    const modal = root.querySelector('[data-article-pcarousel-qv]');
    const body = root.querySelector('[data-article-pcarousel-qv-body]');
    if (!modal || !body || !handle) return;

    modal.hidden = false;
    modal.setAttribute('data-open', 'true');
    document.documentElement.style.overflow = 'hidden';

    const hasCache =
      typeof window.BlogProductQuickviewHasCache === 'function' &&
      window.BlogProductQuickviewHasCache(handle);

    if (!hasCache) {
      body.innerHTML =
        '<div class="article-pcarousel__qv-skeleton"><div class="article-pcarousel__qv-skeleton-media"></div><div class="article-pcarousel__qv-skeleton-content"></div></div>';
      body.classList.add('is-loading');
    }

    const card = document.createElement('blog-product-quickview');
    card.className = 'bpqv';
    card.setAttribute('data-product-handle', handle);
    card.dataset.showColors = root.dataset.quickviewShowColors === 'true' ? 'true' : 'false';

    ensureBlogProductQuickviewScript().then(() => {
      body.innerHTML = '';
      body.appendChild(card);
      body.classList.remove('is-loading');
      // Mount once only — connectedCallback does not fetch
      if (typeof card.mount === 'function') card.mount({ force: true });
    });
  }

  function closeQuickview(root) {
    const modal = root.querySelector('[data-article-pcarousel-qv]');
    const body = root.querySelector('[data-article-pcarousel-qv-body]');
    if (!modal) return;
    modal.setAttribute('data-open', 'false');
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (body) body.innerHTML = '';
  }

  function updatePrimaryAction(card, available, hasSize) {
    const selectBtn = card.querySelector('[data-article-pcard-select-options]');
    const form = card.querySelector('form.article-pcard__form');
    const atc = card.querySelector('[data-article-pcard-atc]');
    const labelAtc = (atc && atc.dataset.labelAvailable) || 'Add to bag';
    const labelSold = (atc && atc.dataset.labelSoldOut) || (selectBtn && selectBtn.dataset.labelSoldOut) || 'Sold out';
    const labelSelect = (selectBtn && selectBtn.dataset.labelSelect) || 'Select options';

    const showSelect = Boolean(hasSize && available && selectBtn);
    const showAtc = !showSelect;

    if (form) {
      if (showAtc) form.removeAttribute('hidden');
      else form.setAttribute('hidden', '');
    }
    if (atc) {
      if (showAtc) atc.removeAttribute('hidden');
      else atc.setAttribute('hidden', '');
      atc.disabled = !available;
      atc.textContent = available ? labelAtc : labelSold;
      atc.classList.toggle('is-soldout', !available);
    }
    if (selectBtn) {
      if (showSelect) selectBtn.removeAttribute('hidden');
      else selectBtn.setAttribute('hidden', '');
      if (showSelect) {
        selectBtn.disabled = false;
        selectBtn.textContent = labelSelect;
        selectBtn.classList.remove('is-soldout');
        selectBtn.setAttribute('aria-haspopup', 'dialog');
      }
    }
  }

  function applySwatchSelection(card, swatch) {
    const image = card.querySelector('[data-article-pcard-image]');
    const variantInput = card.querySelector('[data-article-pcard-variant]');
    const priceEl = card.querySelector('[data-article-pcard-price]');
    const qv = card.querySelector('[data-article-pcard-quickview]');
    const preview = swatch.getAttribute('data-preview-image');
    const handle = swatch.getAttribute('data-product-handle');
    const productId = swatch.getAttribute('data-product-id');
    const variantId = swatch.getAttribute('data-variant-id');
    const price = swatch.getAttribute('data-price');
    const available = swatch.getAttribute('data-available') === 'true';
    const hasSize = swatch.getAttribute('data-has-size') === 'true';
    const productUrl = swatch.getAttribute('data-product-url');

    if (preview && image) {
      image.src = preview;
      card.dataset.defaultImage = preview;
    }
    if (variantInput && variantId) variantInput.value = variantId;
    if (priceEl && price) priceEl.innerHTML = price;
    if (handle) {
      card.dataset.productHandle = handle;
      if (qv) qv.setAttribute('data-product-handle', handle);
    }
    if (productId) {
      card.dataset.productId = productId;
      if (qv) qv.setAttribute('data-product-id', productId);
      const wishlistSlot = card.querySelector('[data-product-card-wishlist-slot]');
      if (wishlistSlot) {
        wishlistSlot.setAttribute('data-product-id', productId);
        if (handle) wishlistSlot.setAttribute('data-product-handle', handle);
      }
    }

    const viewColors = card.querySelector('[data-article-pcard-view-colors]');
    if (viewColors && productUrl) viewColors.setAttribute('href', productUrl);

    const titleLink = card.querySelector('.article-pcard__title a');
    const mediaLink = card.querySelector('.article-pcard__media-link');
    if (productUrl) {
      if (titleLink) titleLink.setAttribute('href', productUrl);
      if (mediaLink) mediaLink.setAttribute('href', productUrl);
    }

    card.dataset.hasSize = hasSize ? 'true' : 'false';
    updatePrimaryAction(card, available, hasSize);

    card.querySelectorAll('[data-article-pcard-swatch]').forEach((el) => {
      el.classList.toggle('is-selected', el === swatch);
      el.setAttribute('aria-pressed', el === swatch ? 'true' : 'false');
    });
  }

  function bindCard(card) {
    const defaultImage = card.dataset.defaultImage || '';

    card.addEventListener('pointerenter', (event) => {
      const qv = event.target.closest('[data-article-pcard-quickview]');
      if (qv && card.contains(qv)) prefetchQuickview(qv.getAttribute('data-product-handle'));
    }, true);

    card.addEventListener('focusin', (event) => {
      const qv = event.target.closest('[data-article-pcard-quickview]');
      if (qv && card.contains(qv)) prefetchQuickview(qv.getAttribute('data-product-handle'));
    });

    card.querySelectorAll('[data-article-pcard-swatch]').forEach((swatch) => {
      swatch.addEventListener('mouseenter', () => {
        const image = card.querySelector('[data-article-pcard-image]');
        const preview = swatch.getAttribute('data-preview-image');
        if (image && preview && image.getAttribute('src') !== preview) {
          image.src = preview;
        }
      });

      swatch.addEventListener('mouseleave', () => {
        requestAnimationFrame(() => {
          if (card.querySelector('[data-article-pcard-swatch]:hover')) return;
          const image = card.querySelector('[data-article-pcard-image]');
          const selected = card.querySelector('[data-article-pcard-swatch].is-selected');
          const restore =
            (selected && selected.getAttribute('data-preview-image')) ||
            card.dataset.defaultImage ||
            defaultImage;
          if (image && restore && image.getAttribute('src') !== restore) {
            image.src = restore;
          }
        });
      });
    });

    card.addEventListener('click', (event) => {
      const closeSize = event.target.closest('[data-article-pcard-size-close]');
      if (closeSize && card.contains(closeSize)) {
        event.preventDefault();
        closeSizePopup(card);
        return;
      }

      const selectBtn = event.target.closest('[data-article-pcard-select-options]');
      if (selectBtn && card.contains(selectBtn)) {
        if (selectBtn.classList.contains('is-soldout') || selectBtn.disabled) {
          event.preventDefault();
          return;
        } 
        if (card.dataset.hasSize === 'true' && card.querySelector('[data-article-pcard-size-popup]')) {
          event.preventDefault();
          openSizePopup(card);
        }
        return;
      }

      const sizeBtn = event.target.closest('[data-article-pcard-size]');
      if (sizeBtn && card.contains(sizeBtn)) {
        event.preventDefault();

        const variantInput = card.querySelector('[data-article-pcard-variant]');
        const variantId = sizeBtn.getAttribute('data-variant-id');
        const available = sizeBtn.getAttribute('data-available') === 'true';

        if (variantInput && variantId) variantInput.value = variantId;

        card.querySelectorAll('[data-article-pcard-size]').forEach((el) => {
          const selected = el === sizeBtn;
          el.classList.toggle('is-selected', selected);
          el.setAttribute('aria-selected', selected ? 'true' : 'false');
        });

        updateSizeAtc(card, available);
        return;
      }

      const swatch = event.target.closest('[data-article-pcard-swatch]');
      if (!swatch || !card.contains(swatch)) return;

      event.preventDefault();
      applySwatchSelection(card, swatch);
    });
  }

  function syncNavToMedia(root) {
    const media = root.querySelector('.article-pcard__media-link, .article-mo-related__media');
    const navs = root.querySelectorAll('.article-pcarousel__nav--long');
    if (!media || !navs.length) return;
    const mediaH = media.getBoundingClientRect().height;
    if (!mediaH) return;
    const top = Math.max(0, mediaH / 2 - 6);
    navs.forEach((nav) => {
      nav.style.marginTop = `${top}px`;
    });
  }

  function clearStickyCardHover(card) {
    if (!card) return;
    card.classList.add('is-unhover');
    const release = () => {
      card.classList.remove('is-unhover');
      window.removeEventListener('mousemove', release);
      window.removeEventListener('pointerdown', release);
    };
    window.addEventListener('mousemove', release, { passive: true });
    window.addEventListener('pointerdown', release, { passive: true });
  }

  function initRoot(root) {
    if (root.dataset.articlePcarouselReady === 'true') return;
    root.dataset.articlePcarouselReady = 'true';

    const track = root.querySelector('[data-article-pcarousel-track]');
    const prev = root.querySelector('[data-article-pcarousel-prev]');
    const next = root.querySelector('[data-article-pcarousel-next]');

    if (track) {
      const onLayout = () => {
        updateNav(root);
        syncNavToMedia(root);
      };
      track.addEventListener('scroll', onLayout, { passive: true });
      window.addEventListener('resize', onLayout);
      onLayout();
      if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(onLayout);
        ro.observe(track);
        const firstMedia = root.querySelector('.article-pcard__media-link, .article-mo-related__media');
        if (firstMedia) ro.observe(firstMedia);
      }

      if (prev) {
        prev.addEventListener('click', () => {
          track.scrollBy({ left: -getSlideStep(track), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', () => {
          track.scrollBy({ left: getSlideStep(track), behavior: 'smooth' });
        });
      }
    }

    root.querySelectorAll('[data-article-pcard]').forEach((card) => {
      bindCard(card);
    });

    // Warm quickview HTML cache for visible cards (cuts open delay)
    ensureBlogProductQuickviewScript().then(() => {
      root.querySelectorAll('[data-article-pcard-quickview]').forEach((btn) => {
        const handle = btn.getAttribute('data-product-handle');
        if (handle) prefetchQuickview(handle);
      });
    });

    root.addEventListener('click', (event) => {
      const viewColors = event.target.closest('[data-article-pcard-view-colors]');
      if (viewColors && root.contains(viewColors)) {
        const card = viewColors.closest('[data-article-pcard]');
        viewColors.blur();
        clearStickyCardHover(card);
      }

      const qvBtn = event.target.closest('[data-article-pcard-quickview]');
      if (qvBtn && root.contains(qvBtn)) {
        event.preventDefault();
        openQuickview(root, qvBtn.getAttribute('data-product-handle'));
        return;
      }

      const closeBtn = event.target.closest('[data-article-pcarousel-qv-close]');
      if (closeBtn && root.contains(closeBtn)) {
        closeQuickview(root);
        return;
      }

      const modal = root.querySelector('[data-article-pcarousel-qv]');
      if (modal && event.target === modal) closeQuickview(root);
    });

    // Returning from PDP tab: kill sticky :hover on cards
    const onTabReturn = () => {
      if (document.visibilityState && document.visibilityState !== 'visible') return;
      const active = document.activeElement;
      if (active && root.contains(active) && typeof active.blur === 'function') {
        active.blur();
      }
      root.querySelectorAll('[data-article-pcard].is-unhover, [data-article-pcard]:hover').forEach((card) => {
        clearStickyCardHover(card);
      });
    };
    document.addEventListener('visibilitychange', onTabReturn);
    window.addEventListener('pageshow', onTabReturn);
    window.addEventListener('focus', onTabReturn);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openCard = root.querySelector('[data-article-pcard].article-pcard--size-open');
      if (openCard) {
        closeSizePopup(openCard);
        return;
      }
      const modal = root.querySelector('[data-article-pcarousel-qv]');
      if (modal && modal.getAttribute('data-open') === 'true') closeQuickview(root);
    });
  }

  function init(root = document) {
    root.querySelectorAll(SELECTOR_ROOT).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) {
      event.target.querySelectorAll('[data-article-pcarousel]').forEach((el) => {
        delete el.dataset.articlePcarouselReady;
      });
      init(event.target);
    }
  });
})();
